import { createRoot } from 'react-dom/client'
import { App } from '@/app/App'
import '@/styles/tokens.css'
import '@/styles/global.css'

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element not found')
}

const root = createRoot(rootElement)
if (import.meta.env.MODE === 'demo') {
  void import('@/app/demoRuntime').then(({ createDemoRuntime }) => {
    root.render(<App runtimeFactory={createDemoRuntime} showUpdatePrompt={false} />)
  }).catch(() => {
    root.render(<p role="alert">模拟数据加载失败，请刷新页面。</p>)
  })
} else {
  root.render(<App />)
}
